import React from 'react'

const Rodape = props => {
    return (
        <footer className='container-fluid text-center'>        
            <p>Todos os direitos reservados à G&S ronda </p>
        </footer>
    )
}

export default Rodape